import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CalendarEvent } from 'calendar-link';

import { AddToCalendarDialogComponent } from '@libs/src/add-to-calendar-dialog/add-to-calendar-dialog.component';

import { CalendarProviders } from '@libs/src/calendar-links/calendar-providers.type';

@Injectable()
export class AddToCalendarDialogService {
  constructor(public dialog: MatDialog) {}

  openDialog(
    calendarEvent: CalendarEvent,
    supportedProviders: CalendarProviders = [
      'google',
      'office',
      'office365',
      'outlook',
      'yahoo',
    ],
  ) {
    return this.dialog.open(AddToCalendarDialogComponent, {
      data: { calendarEvent, supportedProviders },
      maxWidth: '400px',
      width: '95vw',
    });
  }
}
